import { render, staticRenderFns } from "./IntroComp.vue?vue&type=template&id=4d4a0c4d&"
var script = {}
import style0 from "./IntroComp.vue?vue&type=style&index=0&id=4d4a0c4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports